import { render } from "./contentadd.vue?vue&type=template&id=bb7eb282"
import script from "./contentadd.vue?vue&type=script&lang=js"
export * from "./contentadd.vue?vue&type=script&lang=js"

import "./contentadd.vue?vue&type=style&index=0&id=bb7eb282&lang=css"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__